import { render, staticRenderFns } from "./AdminBaseJobs.vue?vue&type=template&id=4f218332"
import script from "./AdminBaseJobs.vue?vue&type=script&lang=js"
export * from "./AdminBaseJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports